var map = {
	"./img/bookmark/acfun.png": 5540,
	"./img/bookmark/bilibili.png": 9739,
	"./img/bookmark/gitee.png": 3792,
	"./img/bookmark/github.png": 2845,
	"./img/bookmark/google.png": 7519,
	"./img/bookmark/jingdong.png": 1631,
	"./img/bookmark/juejin.png": 97,
	"./img/bookmark/mdn.png": 6060,
	"./img/bookmark/python.png": 4624,
	"./img/bookmark/segmentfault.png": 7319,
	"./img/bookmark/sougou-fanyi.png": 2248,
	"./img/bookmark/stackoverflow.png": 1363,
	"./img/bookmark/standrand_cpp.png": 5915,
	"./img/bookmark/taobao.png": 8166,
	"./img/bookmark/wikipedia.png": 5067,
	"./img/bookmark/zhihu.png": 3014,
	"./img/search/baidu.png": 9493,
	"./img/search/bing.png": 3640,
	"./img/search/duckduckgo.png": 5351,
	"./img/search/google.png": 7866,
	"./img/search/search_icon.png": 9413,
	"./img/setting/setting.png": 9905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;